import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getUserData } from "@/lib/api";

type Role = "admin" | "user";

interface RoleRouteProps {
  allowedRoles?: Role[];
  redirectTo?: string;
}

export default function RoleRoute({ allowedRoles, redirectTo = "/dashboard" }: RoleRouteProps) {
  const location = useLocation();
  const user = getUserData();

  if (!user) {
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}
